/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// react-router-dom components
import { useNavigate } from "react-router-dom";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import PasswordStrengthMeter from "utils/PasswordStrengthMeter";
import TextError from "utils/TextError";

// Dashboard example components
import Footer from "examples/Footer";
import PageLayout from "examples/LayoutContainers/PageLayout";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Functions from store
import { resetPassword } from "../../../store";

// Config file

// Cookies
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputAdornment } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import Cookies from "universal-cookie";
const cookies = new Cookies();

function SetPassword({
  setPasswordForNewUser,
  setPasswordForNewUserData,
  isAuth,
  resetPassword,
}) {
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        setIsError(false);
      }, 3000);
    }
  }, [isError]);

  // let email = isAuth.userData.data ? isAuth.userData.data.email : "";
  let loginDetails = cookies.get("forgot-password-for-warehouse");
  let userId = loginDetails?.data?.userId;

  let userDetails = cookies.get(
    "email-for-set-new-password-for-first-login-Warehouse",
  );

  let otpObject = cookies.get("forgot-password-details");
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const [showPassword2, setShowPassword2] = useState(false);
  const handleClickShowPassword2 = () => setShowPassword2(!showPassword2);
  const handleMouseDownPassword2 = () => setShowPassword2(!showPassword2);

  const [showPassword3, setShowPassword3] = useState(false);
  const handleClickShowPassword3 = () => setShowPassword3(!showPassword3);
  const handleMouseDownPassword3 = () => setShowPassword3(!showPassword3);

  const PasswordResetNotification = () =>
    toast.success("Password Changed Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const initialValues = {
    email: userDetails,
    newpassword: "",
    confirmpassword: "",
  };

  const validationSchema = Yup.object({
    oldpassword: Yup.string().required("Enter the old password!"),
    newpassword: Yup.string()
      .required("Enter the new password!")
      .matches(
        /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
        "Password must be min 8 characters, and have 1 Special Character, 1 Uppercase, 1 Number and 1 Lowercase",
      ),
    confirmpassword: Yup.string()
      .oneOf([Yup.ref("newpassword"), ""], "Passwords must match")
      .required("Enter the new password again!"),
  });

  const onSubmit = async (values) => {
    let payload = {
      email: userDetails,
      newPassword: values.newpassword,
      oldPassword: values.oldpassword,
    };

    let res = await resetPassword(payload);

    if (!res.status) {
      setIsError(true);
      setErrorMessage(res?.data?.data.message);
    }
    if (res.status) {
      PasswordResetNotification();
      setTimeout(() => {
        navigate("/authentication/logout");
      }, 2000);
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  return (
    <PageLayout>
      <DefaultNavbar bgColor="black" />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          minHeight: "100vh",
          alignItems: "center",
        }}
      >
        <Card sx={{ width: "30%" }}>
          <MDBox ml={3} mt={2}>
            <MDTypography variant="h4" fontWeight="medium">
              Set New Password
            </MDTypography>
          </MDBox>
          <Divider />
          <MDBox pt={1} pb={3} px={3}>
            <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
              <MDBox mb={2}>
                <MDInput
                  type={showPassword ? "text" : "password"}
                  name="oldpassword"
                  label="Old Password"
                  fullWidth
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.oldpassword}
                  error={
                    formik.touched.oldpassword &&
                    formik.errors.oldpassword &&
                    true
                  }
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        style={{ marginRight: 10 }}
                      >
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {formik.touched.oldpassword && formik.errors.oldpassword && (
                  <TextError msg={formik.errors.oldpassword} />
                )}
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  type={showPassword2 ? "text" : "password"}
                  name="newpassword"
                  label="New Password"
                  fullWidth
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.newpassword}
                  error={
                    formik.touched.newpassword &&
                    formik.errors.newpassword &&
                    true
                  }
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        style={{ marginRight: 10 }}
                      >
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword2}
                          onMouseDown={handleMouseDownPassword2}
                        >
                          {showPassword2 ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <PasswordStrengthMeter password={formik.values.newpassword} />
                {formik.touched.newpassword && formik.errors.newpassword && (
                  <TextError msg={formik.errors.newpassword} />
                )}
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  type={showPassword3 ? "text" : "password"}
                  name="confirmpassword"
                  label="Confirm Password"
                  fullWidth
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.confirmpassword}
                  error={
                    formik.touched.confirmpassword &&
                    formik.errors.confirmpassword &&
                    true
                  }
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        style={{ marginRight: 10 }}
                      >
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword3}
                          onMouseDown={handleMouseDownPassword3}
                        >
                          {showPassword3 ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {formik.touched.confirmpassword &&
                  formik.errors.confirmpassword && (
                    <TextError msg={formik.errors.confirmpassword} />
                  )}
              </MDBox>
              <Collapse in={isError}>
                <Alert
                  //   style={errorStyling}
                  severity="error"
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setIsError(false);
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                >
                  {errorMessage}
                </Alert>
              </Collapse>
              <MDBox mt={4} mb={1}>
                <MDButton
                  style={{ backgroundColor: "red", float: "left" }}
                  // variant="gradient"
                  color="info"
                  type="submit"
                  disabled={!formik.isValid}
                >
                  set password
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        </Card>
      </div>
      <ToastContainer />
      <Footer />
    </PageLayout>
  );
}

const mapStateToProps = (state) => {
  return {
    setPasswordForNewUserData: state.setPasswordForNewUserReducer,
    isAuth: state.login,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    resetPassword: (payload) => dispatch(resetPassword(payload)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(SetPassword);
